import { BASE_URL } from "../constants/appConstants";
import { fetchWithToken, uploadImage } from "../utils/utils";

export const fetchJobTypes = async () => {
  try {
    const end_url = BASE_URL + "/job-types?page=0&size=0";
    const response = await fetchWithToken(end_url);
    if (!response.ok) {
      throw new Error("Failed to fetch job types");
    }
    const jobTypes = await response.json();
    return jobTypes.results;
  } catch (error) {
    throw new Error("Failed to fetch job types");
  }
};

export const createJobType = async (jobTypeData: any) => {
  try {
    const { jobImage } = jobTypeData;

    let imageUrl: any;

    let newJobType = {
      type: jobTypeData.type,
      description: jobTypeData.description,
      productTypeIds: jobTypeData.productTypeIds,
      status: jobTypeData.status,
      jobTypeImageUrl: "",
    };

    if (jobImage) {
      imageUrl = await uploadImage(jobImage);
      newJobType.jobTypeImageUrl = imageUrl.url;
    }

    const end_url = BASE_URL + "/job-types";
    const response = await fetchWithToken(end_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newJobType),
    });
    const newJobTypeCreated = await response.json();
    return newJobTypeCreated;
  } catch (error) {
    throw new Error("Failed to create job type");
  }
};

export const updateJobTypes = async (jobTypeId: string, updatedData: any) => {
  try {
    const end_url = `${BASE_URL}/job-types/${jobTypeId}`;

    const { jobImage, jobImageUrl } = updatedData;

    let imageUrl: any;

    let newJobType = {
      type: updatedData.type,
      description: updatedData.description,
      productTypeIds: updatedData.productTypeIds,
      status: updatedData.status,
      jobTypeImageUrl: "",
    };

    if (jobImage) {
      imageUrl = await uploadImage(jobImage);
      newJobType.jobTypeImageUrl = imageUrl.url;
    } else if (jobImageUrl) {
      newJobType.jobTypeImageUrl = jobImageUrl;
    }

    console.log("newJobType:", newJobType);

    const response = await fetchWithToken(end_url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newJobType),
    });
    const updatedJobType = await response.json();
    return updatedJobType;
  } catch (error) {
    throw new Error("Failed to update job type");
  }
};
